import classnames from 'classnames';
import { FunctionComponent } from 'react';

type SoldProps = {
    className?: string;
};

const Sold: FunctionComponent<SoldProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'sold'}
            viewBox="0 90 250 70"
        >
            <path d="M0 148.4l3.7-4.3c4.3 4.9 11.2 9.6 20.6 9.6 13.6 0 17.4-7.5 17.4-13.2 0-19.4-39.6-9.3-39.6-32.4 0-10.8 9.7-17.6 21.7-17.6 9.9 0 17.2 3.5 22.4 9.3l-3.8 4.2c-4.7-5.7-11.5-8.3-18.9-8.3-8.8 0-15.4 5-15.4 12.2 0 16.9 39.6 7.6 39.6 32.3 0 8.5-5.6 18.7-23.5 18.7-10.9 0-19.2-4.3-24.2-10.5z" />
            <path d="M59.9 124.8c0-19.3 12.7-34.1 32.1-34.1 19.3 0 32.1 14.8 32.1 34.1s-12.8 34.1-32.1 34.1c-19.5 0-32.1-14.8-32.1-34.1zm58.2 0c0-16.8-10.3-29-26.1-29-16 0-26.1 12.2-26.1 29 0 16.6 10.1 29 26.1 29 15.8 0 26.1-12.4 26.1-29z" />
            <path d="M141.3 157.7v-66h5.6v60.9h32v5.1h-37.6z" />
            <path d="M194.6 157.7v-66h21.1c20.5 0 33.4 14.9 33.4 33.1 0 18.3-12.9 33-33.4 33h-21.1zm48.5-32.9c0-15.4-9.9-27.9-27.4-27.9h-15.4v55.7h15.4c17.4 0 27.4-12.4 27.4-27.8z" />
        </svg>
    );
};
export default Sold;
